/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  GuidedSailTimeSlot,
  GuidedSailTimeSlotOptional,
  GuidedSailTimeSlotMetaI,
  GuidedSailTimeSlotTrackedI,
} from "./guided-sail-time-slot";
import {
  GuidedSailTimeSlotTracked,
  GuidedSailTimeSlotMeta,
} from "./guided-sail-time-slot";

/**
 *
 * @export
 * @interface GuidedSailTimeSlotsForDayDTO
 */
export interface GuidedSailTimeSlotsForDayDTOOptional {
  /**
   * Date in format yyyy-MM-dd
   * @type {string}
   * @memberof GuidedSailTimeSlotsForDayDTO
   */
  date?: Date;
  /**
   *
   * @type {Array<GuidedSailTimeSlot>}
   * @memberof GuidedSailTimeSlotsForDayDTO
   */
  timeSlots?: GuidedSailTimeSlotOptional[];
}

export interface GuidedSailTimeSlotsForDayDTO extends GuidedSailTimeSlotsForDayDTOOptional {
  /**
   * Date in format yyyy-MM-dd
   * @type {string}
   * @memberof GuidedSailTimeSlotsForDayDTO
   */
  date: Date;
  /**
   *
   * @type {Array<GuidedSailTimeSlot>}
   * @memberof GuidedSailTimeSlotsForDayDTO
   */
  timeSlots: GuidedSailTimeSlot[];
}

export interface GuidedSailTimeSlotsForDayDTOTrackedI {
  /**
   * Date in format yyyy-MM-dd
   * @type {string}
   * @memberof GuidedSailTimeSlotsForDayDTO
   */
  date?: Date;
  dateIsSet: boolean;
  /**
   *
   * @type {Array<GuidedSailTimeSlot>}
   * @memberof GuidedSailTimeSlotsForDayDTO
   */
  timeSlots?: GuidedSailTimeSlotTrackedI[];
  timeSlotsIsSet: boolean;
}

transformDatesMap.set(
  "GuidedSailTimeSlotsForDayDTO",
  function (model: GuidedSailTimeSlotsForDayDTO) {
    if (typeof model.date == "string") model.date = new Date(model.date);
    const transformDatestimeSlots = transformDatesMap.get("GuidedSailTimeSlot");
    if (transformDatestimeSlots) {
      model.timeSlots?.forEach((sub) => {
        transformDatestimeSlots(sub);
      });
    }
  },
);

export type GuidedSailTimeSlotsForDayDTOMetaI = MetaType<{
  //isDate: true
  //isDatetime: false
  date: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  timeSlots: PropertyMeta<GuidedSailTimeSlotMetaI>;
}>;

export var GuidedSailTimeSlotsForDayDTOMeta: GuidedSailTimeSlotsForDayDTOMetaI =
  {} as GuidedSailTimeSlotsForDayDTOMetaI;
GuidedSailTimeSlotsForDayDTOMeta = typeMeta("GuidedSailTimeSlotsForDayDTO", {
  date: propertyMeta("date", false, true, false, MetaTypesBase.Date),
  timeSlots: propertyMeta(
    "timeSlots",
    true,
    true,
    false,
    GuidedSailTimeSlotMeta,
  ),
});

const metaI = GuidedSailTimeSlotsForDayDTOMeta;

registerMeta(() => {});

export class GuidedSailTimeSlotsForDayDTOTracked implements GuidedSailTimeSlotsForDayDTOTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  date__I?: Date = undefined;
  dateIsSet: boolean = false;
  set date(v: undefined | Date) {
    if (v !== undefined) {
      this.date__I = v;
      this.dateIsSet = true;
    } else {
      this.date__I = v || undefined;
      this.dateIsSet = true;
    }
    this.changeTracker = true;
  }
  get date() {
    return this.date__I;
  }
  timeSlots__I?: GuidedSailTimeSlotTracked[] = undefined;
  timeSlotsIsSet: boolean = false;
  set timeSlots(v: undefined | GuidedSailTimeSlotTracked[]) {
    if (v !== undefined) {
      this.timeSlots__I = v;
      this.timeSlotsIsSet = true;
    } else {
      this.timeSlots__I = v || undefined;
      this.timeSlotsIsSet = true;
    }
    this.changeTracker = true;
  }
  get timeSlots() {
    return this.timeSlots__I;
  }
  constructor(
    config?: GuidedSailTimeSlotsForDayDTOOptional,
    options?: AssignOptions,
  ) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {
    this.timeSlots?.forEach((a) => a.setIds());
  }
  assignFrom(
    config: GuidedSailTimeSlotsForDayDTOOptional,
    options?: AssignOptions,
  ): GuidedSailTimeSlotsForDayDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.date && this.dateApplyFilter(optionsRequired.filter)) {
      this.date = config.date;
      if (optionsRequired.unassign) this.dateIsSet = false;
      else this.dateIsSet = true;
    }
    if (config.timeSlots && this.timeSlotsApplyFilter(optionsRequired.filter)) {
      this.timeSlots = config.timeSlots?.map(
        (a) => new GuidedSailTimeSlotTracked(a, options),
      );
      if (optionsRequired.unassign) this.timeSlotsIsSet = false;
      else this.timeSlotsIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): GuidedSailTimeSlotsForDayDTOTrackedI {
    const cloned = {} as GuidedSailTimeSlotsForDayDTOTrackedI;
    if (
      this.dateIsSetDeep() &&
      this.dateApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.dateIsSet = true;
      cloned.date = this.date;
    } else {
      //cloned.dateIsSet = false
    }
    if (
      this.timeSlotsIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.timeSlotsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.timeSlotsIsSet = true;
      cloned.timeSlots = this.timeSlots
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.timeSlotsIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): GuidedSailTimeSlotsForDayDTOTrackedI {
    if (!this.dateApplyFilter(filter)) this.dateIsSet = false;

    if (!this.timeSlotsApplyFilter(filter)) this.timeSlotsIsSet = false;

    this.timeSlots?.forEach((a) => a.unassignAll(filter));
    return this;
  }
  dateApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      GuidedSailTimeSlotsForDayDTOMeta.date,
      GuidedSailTimeSlotsForDayDTOMeta,
      this.date,
      this,
    );
  }
  dateIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.dateIsSet && this.dateApplyFilter(filter)) return true;

    return false;
  }
  timeSlotsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      GuidedSailTimeSlotsForDayDTOMeta.timeSlots,
      GuidedSailTimeSlotsForDayDTOMeta,
      this.timeSlots,
      this,
    );
  }
  timeSlotsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.timeSlotsIsSet && this.timeSlotsApplyFilter(filter)) return true;

    return this.timeSlots?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.dateIsSetDeep(filter)) return true;
    if (this.timeSlotsIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
